<template>
  <pipeline-layout is-board-style>
    <template v-if="pageLoading">
      <b-loading active></b-loading>
    </template>
    <!--Main Content-->
    <div v-else class="columns is-variable is-2">
      <active-column
        class="column"
        v-for="status in statuses"
        :key="status.id"
        :status="status"
      ></active-column>
    </div>

    <!--Filters-->
    <template #filters>
      <div class="record_count flex flex-vertical-center">
        <p class="record_count--item red">{{ recordCounts.red }}</p>
        <p class="record_count--item yellow">{{ recordCounts.yellow }}</p>
        <p class="record_count--item green">{{ recordCounts.green }}</p>
        leads
      </div>

      <active-filters></active-filters>
    </template>
  </pipeline-layout>
</template>

<script>
import ActiveColumn from "./components/ActiveColumn";
import PipelineLayout from "../../components/PipelineLayout";
import ActiveFilters from "./components/ActiveFilters";
import dates from "../../../../services/dates";
import CancelablePromise from "../../../../services/CancelablePromise";

export default {
  name: "ActivePipelineDesktop",
  components: {
    ActiveFilters,
    PipelineLayout,
    ActiveColumn,
  },
  data() {
    return {
      pageLoading: true,
      reloadingPipelinePromise: null,
      stopWatcherOnLoad: true
    };
  },
  watch: {
    // watches if user changes the value of Pipeline View option
    'pipelineViewId'() {
      if (!this.stopWatcherOnLoad) {
        // resets the record array to avoid duplicates
        this.$store.dispatch("activeState/tearDown");
        this.loadPipelineData()
      }
    },
  },
  computed: {
    pipelineViewId() {
      return this.$store.getters["activeState/pipelineViewId"];
    },
    statuses() {
      return this.$store.getters["pipeline/activeStatusesInView"];
    },
    recordCounts() {
      let red = 0;
      let yellow = 0;
      let green = 0;

      const records = this.$store.getters["activeState/records"];
      const nowDate = dates.getNowISO()

      records.forEach((record) => {
        let nextTaskDueAt = null;
        if (record.nextTask) {
          nextTaskDueAt = record.nextTask.due_at;
        }

        if(dates.isBefore(nextTaskDueAt, nowDate)) {
          red += 1;
        } else if (dates.isBefore(nextTaskDueAt, dates.addDay(nowDate))) {
          yellow += 1;
        } else {
          green += 1;
        }
      });

      return {
        "red": red,
        "yellow": yellow,
        "green": green,
      };
    },
  },
  created() {
    this.stopWatcherOnLoad = true
    this.loadPipelineData()
  },
  destroyed() {
    this.$store.dispatch("activeState/tearDown");
  },
  methods: {
    async loadPipelineData() {
      this.pageLoading = true

      if (this.reloadingPipelinePromise) {
        this.reloadingPipelinePromise.cancel();
      }

      this.reloadingPipelinePromise = CancelablePromise(new Promise(async (resolve) => {
        for (let i=0; i < this.statuses.length; i++) {
          await this.$store.dispatch("activeState/setup", this.statuses[i].id).then(() => {});
        }

        this.pageLoading = false
        this.stopWatcherOnLoad = false
        resolve();
      }))
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables/variables";

.columns {
  height: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.column {
  flex: none;
  max-height: 100%;
  width: $pipelineColumnWidth;
  margin-right: 1rem;
  padding: 0;
}

.record_count {
  color: $text-muted;

  &--item {
    margin-right: 6px;
    font-weight: bold;

    &.red {
      color: $red;
    }

    &.yellow {
      color: $amber;
    }

    &.green {
      color: $green;
    }
  }
}
</style>
